import { render, staticRenderFns } from "./VerDetalleModalTab.vue?vue&type=template&id=d96fdcb0&scoped=true&"
import script from "./VerDetalleModalTab.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleModalTab.vue?vue&type=script&lang=ts&"
import style0 from "./VerDetalleModalTab.vue?vue&type=style&index=0&id=d96fdcb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96fdcb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d96fdcb0', component.options)
    } else {
      api.reload('d96fdcb0', component.options)
    }
    module.hot.accept("./VerDetalleModalTab.vue?vue&type=template&id=d96fdcb0&scoped=true&", function () {
      api.rerender('d96fdcb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Inicio/Mapa/VerDetalleModalTab.vue"
export default component.exports